const contactPersonsData = {
  persons: [
    {
      id: 1,
      name: "Kateřina Johnová",
      position: "Ředitelka vzdělávacího centra",
      contact: {
        phone: "721 764 711",
        email: "katerinahvezd@gmail.com"
      }
    },
    {
      id: 2,
      name: "Šárka Hvězdová",
      position: "Zástupkyně ředitelky",
      contact: {
        phone: "723 627 015",
        email: "shvezdova3@gmail.com"
      }
    }
  ],
  availability: "Jsme vám k dispozici v pracovní dny od 7:30 do 15:30. V době výuky (8:00–15:00) se věnujeme dětem, proto prosíme o trpělivost při telefonickém spojení. Na vaše dotazy rádi odpovíme, ideálně e-mailem nebo se domluvíme na osobní schůzce."
};

export default contactPersonsData; 
